export default {
    fieldTitle: {
        fontSize: { base: 'sm' },
        fontWeight: { base:500 },
        lineHeight: { base: '100%'},
        mb: { base: 2 }
    }
}
